import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useAudio } from '../context/AudioManagementContext';

function ClothingArticle({ onClick, id, selected = false }) {
  const { playClick, playHover } = useAudio();
  const [wait, setWait] = useState(false);
  const clickTimeout = useRef(null);

  const debounceClick = (event) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }
    if (wait) return;
    setWait(true);

    playClick(0.5, () => onClick(id));

    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      setWait(false);
    }, 300);
  };

  const onHover = () => {
    playHover(0.2);
  };

  const imagePath = require(`../asset/img/${id}-icon.png`);

  return (
    <div
      className={`clothing-article pixel-corners-wrapper pixel-corners ${selected && 'selected'}`}
      onClick={debounceClick}
      onTouchStart={debounceClick}
      onMouseEnter={onHover}
    >
      <img src={imagePath} alt={id} />
    </div>
  );
}

ClothingArticle.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  selected: PropTypes.bool
};

export default ClothingArticle;
